interface SchemaObject {
  '@context': string;
  '@type': string;
  [key: string]: unknown;
}

interface SEOHeadProps {
  jsonLd?: SchemaObject[];
}

export default function SEOHead({ jsonLd = [] }: SEOHeadProps) {
  if (jsonLd.length === 0) return null;

  return (
    <>
      {jsonLd.map((ld, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(ld) }}
        />
      ))}
    </>
  );
}